import { lazy, Suspense } from "react";
import { Navigate, Route } from "react-router-dom";

import HdPageLoader from "@hd/ui-kit/hd-page-loader/HdPageLoader";
import CommunicationPostStayPage from "./pages/communication-post-stay/CommunicationPostStayPage";

const CommunicationDetailPage = lazy(
  () => import("./pages/communication-detail/CommunicationDetailPage")
);

const EmailTemplateDetailPage = lazy(
  () => import("./pages/email-template-detail/EmailTemplateDetailPage")
);

const CommunicationDashboardPage = lazy(
  () => import("./pages/communication-dashboard/CommunicationDashboardPage")
);

function useCommunicationRoutes() {
  return (
    <>
      <Route
        path="communications"
        element={
          // redirect to dashboard
          <Navigate to="dashboard" />
        }
      />

      <Route
        path="communications/dashboard/*"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <CommunicationDashboardPage />
          </Suspense>
        }
      />
      <Route
        path="communications/email-template/:id"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <EmailTemplateDetailPage />
          </Suspense>
        }
      />

      <Route
        path="communications/:id"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <CommunicationDetailPage />
          </Suspense>
        }
      />

      <Route
        path="communications/post-stay"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <CommunicationPostStayPage />
          </Suspense>
        }
      />
    </>
  );
}

export default useCommunicationRoutes;
